import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/expenses/claims/new',
}).lazy(() => import('./claims.new.lazy').then((d) => d.Route))
